// Display-only accounting over the Offices API contract. Never a Capacity input.
import { eligibleSpaceFitOffice } from "./seatFit.js";
export const CAPACITY_STATUS_DEFINITION = "Space Fit = assigned today vs installed seats.";
export const marketAssignedToday = m => m.assignmentToday ? m.assignmentToday.assigned?.value : m.totalHeadcount;
export const marketInstalledToday = m => m.assignmentToday ? m.assignmentToday.seats?.value : m.totalSeats;

export function officeAssignedToday(office) {
  if (office.inventoryRow) return office.inventoryRow.latestHeadcount?.totalCount ?? null;
  if (Object.hasOwn(office, "assignedToday")) return office.assignedToday;
  return office.latestHeadcount?.totalCount ?? office.headcount ?? null;
}

export function officeSeatsToday(office) {
  if (office.inventoryRow) return office.inventoryRow.installedCapacity ?? null;
  if (Object.hasOwn(office, "assignmentSeats")) return office.assignmentSeats;
  return office.installedCapacity ?? null;
}

export function knownTotal(offices, valueOf) {
  let subtotal = 0;
  let known = 0;
  const missing = [];
  for (const office of offices) {
    const value = valueOf(office);
    if (value != null && value !== "" && Number.isFinite(Number(value))) {
      subtotal += Number(value);
      known += 1;
    } else {
      missing.push({ id: office.id ?? office.locationId,
        name: office.locationAlias || office.name || office.locationId || office.id });
    }
  }
  return { value: known ? subtotal : null, known, total: offices.length, missing };
}

export function marketAssignment(inventory, marketId) {
  if (!inventory || inventory.loading || ["idle", "loading"].includes(inventory.status)) return { status: "loading" };
  if (inventory.error || inventory.status === "error") return { status: "error", error: inventory.error ?? "Office inventory is unavailable." };
  if (!Array.isArray(inventory.locations)) return { status: "error", error: "Office inventory is incomplete." };
  const offices = inventory.locations.filter(o => o.marketId === marketId && eligibleSpaceFitOffice(o));
  const valid = n => Number.isFinite(n) && n >= 0 ? n : null;
  const fitTotal = valueOf => {
    const coverage = knownTotal(offices, valueOf);
    return { ...coverage, partial: coverage.known < coverage.total };
  };
  return { status: offices.length ? "ok" : "excluded", offices,
    assigned: fitTotal(o => valid(o.latestHeadcount?.totalCount)),
    seats: fitTotal(o => valid(o.installedCapacity)) };
}

export function coverageText(coverage, measure) {
  return coverage?.missing?.length
    ? `Partial ${measure}: missing data for ${coverage.missing.map(o => `${o.name}${o.id && o.name !== o.id ? ` (${o.id})` : ""}`).join(", ")}. ${coverage.known} of ${coverage.total} offices known.`
    : "";
}
